import { withChartLayout } from 'components/common';
import LaboratoryTest from 'components/features/chart/pre-clinical-manager/laboratory-test/LaboratoryTest';

const LaboratoryTestsPage = withChartLayout('Laboratory Tests')(LaboratoryTest);
export default LaboratoryTestsPage;
